<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("F&B Sales Analysis Report") }} <span class="text-sm" style="font-size:12px">(On FnB Delivery
          DateTime)</span>
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="dropDown.cinemas && dropDown.cinemas.length > 0
                ? 'shift-up'
                : ''
                ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
              <multiselect :disabled="isRoleID" :options="dropDown.cinemas" v-model="dropDown.selectedCinema"
                :searchable="true" label="cine_name" track-by="cine_id" placeholder="Select Cinema"
                @input="onSelectCinema($event)" :allowEmpty="false" :showLabels="false"></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                        ✖
                      </button> -->
                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate"
                  v-validate="'required'"></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                        ✖
                      </button> -->
                <Datepicker :monday-first="true" ref="programaticOpen" v-model="toDate" v-validate="'required'">
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click.prevent="GetFnbSalesAnalysis('N')">
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>

      <div v-if="fnbSalesAnalysisData.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center">
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- s -->
        <a target="_blank" @click="GetFnbSalesAnalysis('Y')" title="Download as PDF" download>
          <img class="mx-1" src="@/assets/img/icons/pdf.svg" height="25" width="25" />
        </a>
      </div>

      <div>
        <div class="table-scroll">
          <div>
            <table class="swc-report-table swc_table_header" border="1" v-if="fnbSalesAnalysisData.length > 0">
              <thead class="bg-lightgrey">
                <tr>
                  <th>Admits</th>
                  <th>Qty</th>
                  <!-- <th>ASP</th> -->
                  <th>Gross Revenue</th>
                  <th>Total Tax</th>
                  <!-- <th>CGST</th>
                  <th>SGST</th> -->
                  <th>Net Revenue</th>
                  <th>ACP</th>
                  <th>COGS</th>
                  <th>Conversions</th>
                  <!-- <th>Group Mix %</th>
                  <th>Sales Mix %</th> -->
                  <th>Profit</th>
                  <th>Profit %</th>
                  <th>COGS %</th>
                  <th>SPH</th>
                  <!-- <th>Actual SPH</th> -->
                </tr>
              </thead>
              <tbody>
                <td>
                  {{ currFormat(grandTotal.admits || 0) }}
                </td>
                <td>
                  {{ currFormat(grandTotal.qty || 0) }}
                </td>
                <!-- <td>ASP</td> -->
                <td>{{ currFormat(grandTotal.gross_revenue || 0) }}</td>
                <td>{{ currFormat(grandTotal.tax || 0) }}</td>
                <!-- <td>0.00</td>
                <td>0.00</td> -->
                <td>{{ currFormat(grandTotal.net_revenue || 0) }}</td>
                <td>{{ currFormat(grandTotal.conc_std_cost / grandTotal.qty) }}</td>
                <td>{{ currFormat(grandTotal.conc_std_cost || 0) }}</td>
                <td>{{ currFormat(grandTotal.conversions || 0) }}</td>
                <!-- <td>1.00</td>
                <td>1.00</td> -->
                <td>{{ currFormat(grandTotal.profit || 0) }}</td>
                <!-- <td>{{ currFormat((grandTotal.profit / grandTotal.gross_revenue) * 100) }}</td>
                <td>{{ currFormat((grandTotal.profit / grandTotal.gross_revenue) * 100) }}</td> -->
                <td>{{ currFormat(((grandTotal.net_revenue - grandTotal.conc_std_cost) / grandTotal.net_revenue) * 100)
                  }}
                </td>
                <td>{{ currFormat((grandTotal.conc_std_cost / grandTotal.net_revenue) * 100) }}</td>
                <td>{{ currFormat(grandTotal.sph || 0) }}</td>
                <!-- <td>Actual SPH</td> -->
              </tbody>
            </table>
          </div>

          <table class="swc-report-table  mt-5  performance-report-table" border="1"
            v-if="fnbSalesAnalysisData.length > 0">
            <thead class="bg-lightgrey">
              <tr>
                <th rowspan="2">Items</th>
                <th colspan="">Units</th>
                <th colspan="">SP</th>
                <th colspan="">Gross Revenue</th>
                <th colspan="">Tax</th>
                <th colspan="">Tax %</th>
                <th colspan="">Net Revenue</th>
                <th colspan="">Cost Price</th>
                <th colspan="">Conc. Std Cost</th>
                <th>Conversions</th>
                <th>Group Mix</th>
                <th>F&B Sales Mix</th>
                <th>Profit</th>
                <th>Margin</th>
                <th>Cogs %</th>
                <th>SPH</th>
                <!-- <th>Actual SPH</th> -->
              </tr>
            </thead>
            <template v-for="(categoryData, categoryIndex) in fnbSalesAnalysisData">
              <tr class="distName" style="background-color: #E8E8E8">
                <th class="text-left " colspan="17">
                  {{ categoryData.category_name }}
                </th>
              </tr>
              <template v-for="(fnbData, fnbIndex) in categoryData.categoryData">
                <tr>
                  <td class="text-left">
                    {{ fnbData.item_name }}
                  </td>
                  <td class="text-right">
                    {{ fnbData.admits }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.selling_price) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.gross_revenue) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.tax_amount) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.tax_percentage) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.net_revenue) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.cost_price) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.conc_std_cost) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.conversions) }}
                  </td>
                  <td class="text-right">
                    1.00
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.fnb_sales_mix) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.profit) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.margin_cogs_percentage) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.margin_cogs_percentage) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbData.sph) }}
                  </td>
                  <!-- <td class="text-right">
                       Actuel SPH
                    </td>  -->
                </tr>
              </template>

              <tr class="concession_blue">
                <td colspan="" class="text-left font-weight-bold">{{ categoryData.category_name }}</td>
                <td class="text-right font-weight-bold">
                  {{
                    categoryData.categoryTotals.admits
                  }}
                </td>
                <td class="text-right font-weight-bold">
                  {{
                    currFormat(categoryData.categoryTotals.selling_price)
                  }}
                </td>
                <td class="text-right font-weight-bold">
                  {{
                    currFormat(categoryData.categoryTotals.gross_revenue)
                  }}
                </td>
                <td class="text-right font-weight-bold">
                  {{
                    currFormat(categoryData.categoryTotals.tax)
                  }}
                </td>
                <td class="text-right font-weight-bold">
                  -
                </td>
                <td class="text-right font-weight-bold">
                  {{
                    currFormat(categoryData.categoryTotals.net_revenue)
                  }}
                </td>
                <td class="text-right font-weight-bold">
                  {{
                    currFormat(categoryData.categoryTotals.cost_price)
                  }}
                </td>
                <td class="text-right font-weight-bold">
                  {{
                    currFormat(categoryData.categoryTotals.conc_std_cost)
                  }}
                </td>
                <td class="text-right font-weight-bold">
                  {{
                    currFormat(categoryData.categoryTotals.conversions)
                  }}
                </td>
                <td class="text-right font-weight-bold">
                  1.00
                </td>
                <td class="text-right font-weight-bold">
                  {{
                    currFormat(categoryData.categoryTotals.fnb_sales_mix)
                  }}
                </td>
                <td class="text-right font-weight-bold">
                  {{
                    currFormat(categoryData.categoryTotals.profit)
                  }}
                </td>
                <td class="text-right font-weight-bold">
                  {{
                    currFormat(categoryData.categoryTotals.margins)
                  }}
                </td>
                <td class="text-right font-weight-bold">
                  {{
                    currFormat(categoryData.categoryTotals.margins)
                  }}
                </td>
                <td class="text-right font-weight-bold">
                  {{
                    currFormat(categoryData.categoryTotals.sph)
                  }}
                </td>
                <!-- <td class="text-right font-weight-bold">
                   45
                  </td> -->


              </tr>
            </template>
            <thead class="bg-lightgrey">
              <tr>
                <th class="text-left" colspan="">Grand Total</th>
                {{ currFormat(grandTotal.qty || 0) }}
                <th class="text-right">
                  {{ currFormat(grandTotal.selling_price || 0) }}
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.gross_revenue || 0) }}
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.tax || 0) }}
                </th>
                <th class="text-right">
                  -
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.net_revenue || 0) }}
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.cost_price || 0) }}
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.conc_std_cost || 0) }}
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.conversions || 0) }}
                </th>
                <th class="text-right">
                  -
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.fnb_sales_mix || 0) }}
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.profit || 0) }}
                </th>
                <th class="text-right">
                  {{ currFormat((grandTotal.conc_std_cost / grandTotal.gross_revenue) * 100) }}
                </th>
                <th class="text-right">
                  {{ currFormat((grandTotal.conc_std_cost / grandTotal.gross_revenue) * 100) }}
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.sph || 0) }}
                </th>
                <!-- <th class="text-right">
                  actual sph
                 </th> -->

              </tr>
            </thead>
          </table>
        </div>
      </div>
      <table class="swc-report-table swc_table_header table-scroll" border="1" v-if="fnbSalesAnalysisData.length === 0">
        <thead class="bg-lightgrey">
          <tr>

            <th rowspan="2">Items</th>
            <th colspan="">Units</th>
            <th colspan="">SP</th>
            <th colspan="">Gross Revenue</th>
            <th colspan="">Tax</th>
            <th colspan="">Tax %</th>
            <th colspan="">Net Revenue</th>
            <th colspan="">Cost Price</th>
            <th colspan="">Conc. Std Cost</th>
            <th>Conversions</th>
            <th>Group Mix</th>
            <th>F&B Sales Mix</th>
            <th>Profit</th>
            <th>Margin</th>
            <th>Cogs %</th>
            <th>SPH</th>
            <th>Actual SPH</th>
          </tr>

        </thead>
        <tbody>
          <tr>
            <td colspan="17">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      fnbSalesAnalysisData: [],
      grandTotal: {}

    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
  },
  watch: {},
  mounted() { },
  methods: {
    moment,
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    GetFnbSalesAnalysis(isPdf = "N") {
      this.fnbSalesAnalysisData = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isPdf,
      };
      ReportsService.GetFnbSalesAnalysis(payload)
        .then((response) => {
          const { data } = response;

          if (data.status && data.Records.length > 0) {
            this.fnbSalesAnalysisData = [...data.Records];
            //console.log("fnbSalesAnalysisData",this.fnbSalesAnalysisData)
            this.grandTotal = data.grandTotal
            console.log("grandTotal", this.grandTotal)

            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession_blue {
  background-color: #c5d6f0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/fnbSalesAnalysis.vue